import { WorkOrderState } from '../../interfaces'
import { WorkOrderStateAction } from '../actions/workOrderStateActions'
import { GET_WORKORDERSTATE_EXITO } from '../types/workOrderStateActionsTypes'

export interface WorkOrderStateState {
  workOrderStatesState: {
    workOrderStates?: WorkOrderState[] | undefined
    error?: string | undefined
  }
}

const initialState: WorkOrderStateState = {
  workOrderStatesState: { workOrderStates: [], error: '' }
}

export const workOrderStateReducer = (
  state: WorkOrderStateState = initialState,
  action: WorkOrderStateAction
): WorkOrderStateState => {
  if (action.type === GET_WORKORDERSTATE_EXITO) {
    return {
      ...state,
      workOrderStatesState: {
        workOrderStates: action.workOrderStates,
        error: action.error
      }
    }
  }
  return state
}
